// for development
// module.exports = {
//   //api:"https://floating-sands-33943.herokuapp.com/api",
//   api: "http://192.168.2.165:9001/api",
//   imageDomain: "http://192.168.2.165:9998",
//   singleImageURL:"http://192.168.2.165:9999",
//   multipleImageURL:"http://192.168.2.165:9998",
// };

// for production
module.exports = {
  //api:"https://floating-sands-33943.herokuapp.com/api",
  api: "http://192.168.2.165:9001/api",
  imageDomain: "https://mimg.guptarealtors.com",
  singleImageURL:"https://simg.guptarealtors.com",
  multipleImageURL:"https://mimg.guptarealtors.com",
};

//module.exports = require('./keys_dev');

// if (process.env.NODE_ENV === 'production') {
//   module.exports = require('./keys_prod');
// } else {
//   module.exports = require('./keys_dev');
// }
